import { Question } from '../../gds-api-client';
import get from 'lodash/get';

const addMealQuestionToQuestions = (
  questions: Question[] | undefined,
  mealQuestion: Question | null | undefined
): Question[] | undefined => {
  const mealOptions = get(mealQuestion, 'options', []) || [];
  const optionsWithText = mealOptions.filter(o => o && o.text && o.text.trim());

  if (!mealQuestion || !get(optionsWithText, 'length')) {
    return questions;
  }

  const mealWithProperOptions = { ...mealQuestion, options: optionsWithText };

  if (!questions || !questions.length) {
    return [mealWithProperOptions];
  }

  const existingMealQuestionIdx = questions.findIndex(q => q.id === mealQuestion.id);

  if (existingMealQuestionIdx === -1) {
    return [...questions, mealWithProperOptions];
  }

  return questions.map((q, i) => {
    if (i === existingMealQuestionIdx) return mealWithProperOptions;
    return q;
  });
};

export default addMealQuestionToQuestions;
